import customAxios from "./axiosConfig";
import store from '../../store'

const CostService = {
    list: function (params) {
        var api_url = window.Urls["v3:cost-list"]();
        return customAxios.get(api_url, {params: params});
    },
    loadNextPage: function (next_url) {
        return customAxios.get(next_url);
    },
    customerList: function (params) {
        var api_url = window.Urls["cost_customer_list"]();
        return customAxios.get(api_url, {params: params});
    },
    activeYears: function (params) {
        var api_url = window.Urls["cost_years"]();
        return customAxios.get(api_url, {params: params});
    },
    update: function (pk, data) {
        var url = window.Urls['cost-detail'](pk);
        var headers = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        const getFormData = object => Object.keys(object).reduce((formData, key) => {
            if(Array.isArray(object[key])){
                formData.append(key, JSON.stringify(object[key]));
            }else{
                formData.append(key, object[key]);
            }
            return formData;
        }, new FormData());
        return customAxios.put(url, getFormData(data), headers);
    },
    create: function (data) {
        var url = window.Urls["cost-list"]();
        var headers = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        // TODO
        const getFormData = object => Object.keys(object).reduce((formData, key) => {
            if(Array.isArray(object[key])){
                formData.append(key, JSON.stringify(object[key]));
            }else{
                formData.append(key, object[key]);
            }
            return formData;
        }, new FormData());
        return customAxios.post(url, getFormData(data), headers);
    },
    retrieve: function (pk, params) {
        var api_url = window.Urls["cost-detail"](pk);
        return customAxios.get(api_url, {params: params});
    },
    totalAmounts: function (params) {
        var api_url = window.Urls["cost_totals"]();
        return customAxios.get(api_url, {params: params});
    },
    total: function (params) {
        var api_url = window.Urls["cost_total"]();
        return customAxios.get(api_url, {params: params});
    },
    toggleComplete: function (pk) {
        var api_url = window.Urls['cost_toggle_completed'](pk);
        return customAxios.get(api_url);
    },
    destroy: function (pk) {
        var url = window.Urls["cost-detail"](pk);
        return customAxios.delete(url);
    },
    listTransactions: function(pk){
        var api_url = window.Urls["cost_list_transactions"](pk);
        return customAxios.get(api_url);
    },
    deleteTransaction: function(pk, data){
        var api_url = window.Urls["cost_remove_transaction"](pk);
        var headers = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        const getFormData = object => Object.keys(object).reduce((formData, key) => {
            formData.append(key, object[key]);
            return formData;
        }, new FormData());
        return customAxios.post(api_url, getFormData(data), headers);
    },
    addTransaction (cost_id, data) {
        const api_url = window.Urls["cost-add-transaction"](cost_id)
        return customAxios.post(api_url, data)
    },
    removeTransaction (cost_id, data) {
        const api_url = window.Urls["cost-remove-transaction"](cost_id)
        return customAxios.post(api_url, data)
    },
    prepareCostForUpload: function(cost){
        var image = cost.image;
        cost = JSON.parse(JSON.stringify(cost));    // DEEP CLONE
        if(!cost.customer){
            cost.customer = "";
            cost.project = "";
        }
        if(!cost.cost_type){
            // delete cost.cost_type;
            cost.cost_type = "";
        }
        if(!cost.image){
            delete cost.image;
        }else{
            cost.image = image;
        }
        if(!cost.project){
            cost.project = "";
        }
        if(!cost.supplier){
            cost.supplier = "";
        }
        if(!cost.retention_tax_percentage){
            delete cost.retention_tax_percentage;
        }
        if(!cost.retention_tax_amount){
            delete cost.retention_tax_amount;
        }
        var cost_lines = cost.cost_lines;
        const current_company = store.getters['main/getCurrentCompany']
        if (current_company.country === 'ES'){
            if(!cost.retention_tax_amount){
                cost.retention_tax_amount = 0;
            }
            var totalAmount = 0;
            if(cost.subtotal_amount) {
                totalAmount += parseFloat(cost.subtotal_amount);
            }
            if(cost.retention_tax_amount) {
                totalAmount += parseFloat(cost.retention_tax_amount);
            }
            for (var i in cost_lines){
                if (cost_lines[i].amount) {
                    totalAmount += parseFloat(cost_lines[i].amount);
                }
            }
            cost.amount  = Math.round(totalAmount*100)/100;
        }
        cost.cost_lines = [];
        for (var a_line in cost_lines) {
            if (cost_lines[a_line].amount) {
                cost.cost_lines.push(cost_lines[a_line]);
            }
        }
        return cost;
    },
    selectSupplierCandidate: function(supplierCandidates) {
        var api_url = window.Urls["company-profile-supplier-candidates"]();
        return customAxios.post(api_url, supplierCandidates);
    },
    count: function (params){
        var api_url = window.Urls["cost-count"]();
        return customAxios.get(api_url, {params: params});
    },
    totalNet(params){
        var api_url = window.Urls["cost-total-net"]();
        return customAxios.get(api_url, {params: params});
    },
    downloadCostsZip(params){
        var api_url = window.Urls["v3:cost_export_costs_zip"]();
        return customAxios.get(api_url, {params: params});
    },
    getNextCostNumber(data) {
        const current_company = store.getters['main/getCurrentCompany']
        var api_url = window.Urls['cost-next-cost-number'](current_company.id)
        return customAxios.post(api_url, data)
    },
    getNextCostNumberByCompanyId(data, company_id) {
        var api_url = window.Urls['cost-next-cost-number'](company_id)
        return customAxios.post(api_url, data)
    }
};

export default CostService;